export default async function makeRequest(path, { user, password }) {
  try {
    let headers = new Headers({
      Authorization: `Basic ${btoa(`${user}:${password}`)}`
    })
    const response = await fetch(`${process.env.API_HOST}/rest/${path}`, {
      headers
    })

    if (response.status === 404) {
      return {
        code: 404,
        status: 'error',
        message: 'Account nicht gefunden.'
      }
    }

    return response.json()
  } catch (err) {
    console.error(err)
  }
}
